/**
 *
 * Post to the global event bus with a jQuery obect every time
 * a fileinput changes. This is useful for setting up decoupled
 * preview areas for fileinputs.
 *
 *
 * Usage:
 *
 *  data-sw-fileinput-changed="name of event to post on global event bus"
 *    If empty, the event is: 'form-fileinput-changed'
 *
 *  @publishes form-fileinput-changed|overridable <$target>
 * 
 */

var $ = require('./../sw-jquery');
var sw = require('./../../lib/sw');

$(function() {
  $('body').on('change input[type=file]', function(e) {
    var $fileinput = $(e.target);

    var eventName = $fileinput.data('swFileinputChanged') || 'form-fileinput-changed';

    sw.trigger(eventName, $fileinput);
  });
});
